/**
 * translation/conversationApi.js — Sprint 1 refactor (2026-05-20)
 *
 * Trước: REACT_APP_OPENAI_KEY + user_token query param + /stream/translate.
 * Sau:   gateway POST /api/v1/llm-gateway/chat/stream với JWT, tool='translation'.
 *
 * Backend routing → Claude Haiku 4.5 (batch translate).
 */

import { streamChat, streamChatLegacy, RateLimitError } from '../_shared/llmGateway';

const TOOL = 'translation';

function buildTranslationPrompt(question, from_language, to_language) {
    const src = from_language || 'auto-detect';
    const dst = to_language || 'English';
    return (
        `You are a professional translator. Translate the following text from ${src} to ${dst}. ` +
        'Preserve formatting (markdown, lists, code blocks). Reply with ONLY the translated text — no explanations.'
    );
}

/**
 * Streaming translate. Chữ ký cũ:
 *   fetchAnswerSteaming(question, apiKey, from_language, to_language, onEvent)
 */
export function fetchAnswerSteaming(question, _apiKey, from_language, to_language, onEvent, opts = {}) {
    return streamChatLegacy({
        tool: TOOL,
        question,
        history: [],
        systemPrompt: buildTranslationPrompt(question, from_language, to_language),
        signal: opts.signal,
        onEvent,
    }).catch((e) => {
        if (e instanceof RateLimitError) {
            onEvent?.(new MessageEvent('message', { data: JSON.stringify({ type: 'error', detail: e.message, tool: TOOL, status: 429 }) }));
        }
        throw e;
    });
}

/**
 * Non-streaming grammar check. Trả về string suggestion.
 * Trước: /stream/grammar_check leak api_key. Giờ tận dụng cùng gateway nhưng
 * buffer toàn bộ delta trước khi resolve.
 */
export async function fetchGrammarCheckSuggestion(question, opts = {}) {
    let buffer = '';
    try {
        await streamChat({
            tool: TOOL,
            messages: [{ role: 'user', content: question }],
            systemPrompt:
                'You are a grammar-check assistant. Identify mistakes and reply with concise corrections in the same language as the input.',
            signal: opts.signal,
            onText: (delta) => {
                buffer += delta;
            },
        });
        return buffer || null;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('grammar_check failed:', e);
        return null;
    }
}
